import styled from "styled-components";

const PluginWrapper = styled.div.attrs({
  className: "pluginWrapper z-2 w-100 right-0 left-0 absolute bottom-0 bg-white tl overflow-auto"
})`
  box-shadow: 0px -2px 18px 0px rgba(0, 0, 0, 0.075);
  max-width: 768px;
  margin: 0 auto;
  top: 15vh;
  box-sizing: border-box;
  line-height: 1.33rem;
  font-size: 1rem;
`;

export default PluginWrapper;
